import React from 'react'

import BulkImport from '../bulk-import'

const WriteNowImport = () => {
  return (
    <BulkImport
      title='Import WriteNow Groups'
      uploadPath='admin/users/writenow_import'
      templatePath='admin/users/writenow_import/template'
    >
      Import users into WriteNow sessions and groups. This import process will:
      <ul>
        <li>Create the user if they do not exist, using email as a unique identifier</li>
        <li>Create the group within the specified session ID, if it does not exist</li>
        <li>Ensure the user is added to the group</li>
      </ul>
    </BulkImport>
  )
}

export default WriteNowImport
